import { Component,OnInit } from '@angular/core';
import { Service } from '../../../../class/service';
import { Cookies } from '../../../../class/cookies';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs/Rx';
import { QuickSearch } from '../../../../class/search';
import { View } from '../../view';
import 'rxjs/add/operator/debounceTime';

@Component({
  selector: 'app-pais',
  templateUrl: './pais.component.html',
  styleUrls: ['./pais.component.css']
})
export class PaisComponent extends View implements OnInit {
  
  
	//Modelo de datos
	private model: Object = { PKCodigo:0 };
	//Referencia del codigo 
  private pk:Object = { PKCodigo:0 }
	/*
    == Aqui iniciar componentes personalizados  ==
    id="nombre" -> private nombre = new FormControl();
    */
	private PKCodigo = new FormControl();
	private existe_pk:boolean = false;

    /*
    == Aquibusquedas rapidas ==
    [quickSearch] -> private qsNombre:QuickSearch;    -> estructura de la busqueda rapida
    [setData]     -> private qsSetNombre:Object;      -> pasar los datos al buscador { key: '',value: ''}
    (getData)     -> private qsGetNombre(rs:Objest){} -> funcion para los resultados de la busqueda rapida
     */

	constructor(public service: Service, public cookies: Cookies) {
		super(service,cookies,"pais-component");
		super.serviceNmae("pais");
	}

	ngOnInit() {
		super.filter({
			column:[
				{ name: 'PKCodigo', nickname: 'Codigo' },
				{ name: 'nombre', nickname: 'Nombre' },
			]
		});

		/*
        == Aqui inicializar la estructura de la busquedas rapidas ==
        this.qsNombre = {
            label: 'Label',
            required: true || false,
            search: {
                title: 'Title',
                service: 'service',
                column:[
                    {
                        name: 'nombreBd',
                        nickname: 'Nombre',
                        visible: true || false
                    }
                ]
            }
        }
        */		
		this.PKCodigo.valueChanges
		.debounceTime(500)
		.subscribe(a => {
			if(this.action == 'Guardar'){
				if((a != undefined || a != null) && (a != '' || a != this.model["PKCodigo"])){
					this.model["PKCodigo"] = a;
					this.validarPk();
				}
			}
		});
	}

	//Un nuevo registro, iniciando datos
	private NEW(): void {
        this.resetComponent();
		this.list = false;
		this.action = 'Guardar';
	}

    private resetComponent():void {
        /*
        == Aqui limpiar modelos y objetos de las busquedas rapidas y 
        cualquier otro elemento que necesite limpiarse ==
        */
        this.model = {};
    }

	//Editar en base al codigo de referencia
	private EDIT(pk_: Object): void {
		this.pk = pk_;
		this.action = "Actualizar";
		this.list = false;
		this.PKCodigo.disable();
		this.getModelById();
	}

	//Para obtener y cargar el registro seleccionado
	private getModelById(): void {
		this.state = !this.state;
		this.service
        .GET('pais/show/' + this.pk["PKCodigo"], '')
        .subscribe(res => {
			this.model = res["show"];
			/*
            == Aqui llenar el/los metodos de las busquedas rapidas ==
            */
			this.state = !this.state;
		}, err => {
			console.log(err);
			this.state = !this.state;
		});
	}

	//Validar si guardar o modificar
	private actionCrud(): void {
		if (this.action.toUpperCase() == "GUARDAR") {
			this.save();
		} else {
			this.update();
		}
	}

	//Para eliminar el registro
	private DELETE(pk_: Object): void {
		this.state = !this.state;
		this.service.DELETE('pais/delete/' + pk_["PKCodigo"]).subscribe(res => {
			this.getList(this.pagination["current_page"], "");
			if (res["destroy"]) {
				this.openMd("El registro se elimino correctamente", "success");
			} else {
				this.openMd("El registro no se elimino", "danger");
			}
			this.state = !this.state;
		}, err => {
			console.log(err);
			this.state = !this.state;
			this.openMd(err, "danger");
		});
	}

	//Guardar el registro
	private save(): void {
		this.state = !this.state;
		this.service.POST('pais', { data: JSON.stringify(this.model) }).subscribe(res => {
			this.state = !this.state;
			this.list = !this.list;
			if(res["create"]){
				this.openMd('Registro guardado corectamente','success');
			}
			this.getList(1, "");
		}, err => {
            this.openMd(err,'danger');
			this.state = !this.state;
		});
	}

	//Modificar el registro
	private update(): void {
		this.state = !this.state;

		this.service
        .PUT('pais/update/' + this.pk["PKCodigo"], { data: JSON.stringify(this.model) })
        .subscribe(res => {			
			if (res["update"]) {
				this.state = !this.state;
				this.getList(1,"");
				this.openMd("El registro se ha modificado correctamente", "success");
				this.list = !this.list;
			} else {
				this.openMd("El registro no se ha podido modificar", "danger");
			}
		}, err => {
			console.log(err);
		});
	}

	
	private validarPk():void{
		this.service.GET('pais/validarPk/'+this.model["PKCodigo"],'').subscribe(res => {
			this.existe_pk = res["validarPk"];
			if(this.existe_pk){
				this.openMd('El codigo ingresado ya se encuentra registrado','danger');
			}
		}, err => {
            this.openMd(err,'danger');
		});
	}

}



// WEBPACK FOOTER //
// ./src/app/component/module/contable/pais/pais.component.ts